// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1O4v8","text":"SelectPayment_text__3EyUc","title":"SelectPayment_title__2sSwo","btn":"SelectPayment_btn__sRynl"};